import { BookOpen, Trophy, Crown, Settings, UserRound, Volume2, VolumeX, Wallet, Brain, Dice5, Sparkles, Dumbbell, Megaphone, HeartCrack, Flame, TriangleAlert, Gamepad2, Drumstick, Star, Rocket, Sunrise, Scale, Theater, Moon, Baby, Pencil, Leaf, Tv, Map, Egg, Wrench, Soup, Footprints, Ghost, TrendingDown, Flag, X, ArrowRight, ArrowLeft, Hourglass, Microscope, Palmtree, Smile, CircleHelp, LockKeyhole, Phone, ShieldCheck, type LucideIcon } from 'lucide-react'

const icons: Record<string, LucideIcon> = {
  history: BookOpen, medals: Trophy, vip: Crown, settings: Settings, account: UserRound,
  sound: Volume2, muted: VolumeX, close: X, next: ArrowRight, back: ArrowLeft,
  phone: Phone, shield: ShieldCheck,
  '📖': BookOpen, '📚': BookOpen, '🏆': Trophy, '👑': Crown, '⚙': Settings, '☻': UserRound,
  '💰': Wallet, '💸': Wallet, '🧠': Brain, '🎲': Dice5, '💅': Sparkles, '💪': Dumbbell,
  '📢': Megaphone, '💔': HeartCrack, '🔥': Flame, '⚠': TriangleAlert, '🎮': Gamepad2,
  '🍖': Drumstick, '🐔': Drumstick, '⭐': Star, '🌟': Star, '✨': Sparkles, '✦': Sparkles,
  '🚀': Rocket, '🌅': Sunrise, '⚖': Scale, '🎭': Theater, '🎪': Theater, '😴': Moon,
  '👶': Baby, '📝': Pencil, '🧘': Leaf, '🍀': Leaf, '📺': Tv, '🗺': Map, '🥚': Egg,
  '🔩': Wrench, '🥣': Soup, '🍚': Soup, '🚶': Footprints, '👻': Ghost, '🧟': Ghost,
  '⚰': Ghost, '📉': TrendingDown, '🏁': Flag, '⏳': Hourglass, '🔬': Microscope,
  '🏝': Palmtree, '🎩': Crown, '🕶': UserRound, '🤡': Theater, '🤪': Smile, '😐': Smile,
  '🤫': LockKeyhole, '🫥': Ghost, '🐷': Wallet, '🐶': HeartCrack, '🐟': Leaf, '🎱': Dice5,
  '🪵': Leaf, '→': ArrowRight, '←': ArrowLeft
}

/** Story icon tokens are presentation data, rendered as consistent SVGs. */
export function UiIcon({ name, className = '' }: { name: string; className?: string }) {
  const Icon = icons[name.replace(/\uFE0F/g, '')] || CircleHelp
  return <Icon className={`ui-icon ${className}`.trim()} aria-hidden="true" focusable="false" strokeWidth={1.8} />
}

export function IconText({ text }: { text: string }) {
  return <>{text.split(/(\p{Extended_Pictographic}\uFE0F?)/u).map((part, index) => /\p{Extended_Pictographic}/u.test(part) ? <UiIcon key={index} name={part} /> : part)}</>
}
